module.exports = "/images/nonSelectedIcon.svg?d406c4e5eb4a562d2ce2ed0fe142146a";